import { render, staticRenderFns } from "./ExpenseSetting.vue?vue&type=template&id=06beb807&"
import script from "./ExpenseSetting.vue?vue&type=script&lang=js&"
export * from "./ExpenseSetting.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSetting.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports